import React from 'react'
import { Link } from 'react-router-dom'


export default function ProductsBrief() {
  return (
    <>
      <section className='section'>
        <div className="container">
          <h3 className='main-title text-center'>Products</h3>
          <div className="row">
            <div className="col-lg-12">
              <div className="contenido mb-4" id="m-tabs">
                <ul className="nav nav-tabs tab-align">
                  <li className="nav-item">
                    <Link className="nav-link active" data-bs-toggle="tab" to="#centerless">
                      Centerless Grinding Machine
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" data-bs-toggle="tab" to="#cylindrical">
                      Cylindrical Grinding Machine
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" data-bs-toggle="tab" to="#internal">
                      Internal Grinding Machines
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" data-bs-toggle="tab" to="#angular">
                      Angular grinding machines
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" data-bs-toggle="tab" to="#spm">
                      SPM Grinding Machines
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="tab-content">
                <div className="tab-pane active" id="centerless">
                  <div className="row mb-2 justify-content-center">
                    <div className="col-lg-4 col-md-6 col-12 mb-4">
                      <Link to="">
                        <div className='product-list'>
                          <div className="product-img-area">
                            <img src="assets/images/service/14.jpg" alt="Business-service" />
                            <div className='product-overlay'></div>
                          </div>
                          <h5>Hydraulic Centerless Grinding Machine</h5>
                          <p>Commodo gravida quamta sodales pulvinar habitant tristique auctore sapien pretiumto turpis dignissim mus feugiat</p>
                        </div>
                      </Link>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12 mb-4">
                      <Link to="">
                        <div className='product-list'>
                          <div className="product-img-area">
                            <img src="assets/images/service/14.jpg" alt="Business-service" />
                            <div className='product-overlay'></div>
                          </div>
                          <h5>Hydraulic Centerless Grinding Machine</h5>
                          <p>Commodo gravida quamta sodales pulvinar habitant tristique auctore sapien pretiumto turpis dignissim mus feugiat</p>
                        </div>
                      </Link>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12 mb-4">
                      <Link to="">
                        <div className='product-list'>
                          <div className="product-img-area">
                            <img src="assets/images/service/14.jpg" alt="Business-service" />
                            <div className='product-overlay'></div>
                          </div>
                          <h5>Hydraulic Centerless Grinding Machine</h5>
                          <p>Commodo gravida quamta sodales pulvinar habitant tristique auctore sapien pretiumto turpis dignissim mus feugiat</p>
                        </div>
                      </Link>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12 mb-4">
                      <Link to="">
                        <div className='product-list'>
                          <div className="product-img-area">
                            <img src="assets/images/service/14.jpg" alt="Business-service" />
                            <div className='product-overlay'></div>
                          </div>
                          <h5>Hydraulic Centerless Grinding Machine</h5>
                          <p>Commodo gravida quamta sodales pulvinar habitant tristique auctore sapien pretiumto turpis dignissim mus feugiat</p>
                        </div>
                      </Link>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12 mb-4">
                      <Link to="">
                        <div className='product-list'>
                          <div className="product-img-area">
                            <img src="assets/images/service/14.jpg" alt="Business-service" />
                            <div className='product-overlay'></div>
                          </div>
                          <h5>Hydraulic Centerless Grinding Machine</h5>
                          <p>Commodo gravida quamta sodales pulvinar habitant tristique auctore sapien pretiumto turpis dignissim mus feugiat</p>
                        </div>
                      </Link>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12 text-center">
                      <Link className="btn btn-primary" to="">
                        View All
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="tab-pane fade" id="cylindrical">
                  <div className="row mb-2 justify-content-center">
                    <div className="col-lg-4 col-md-6 col-12 mb-4">
                      <Link to="">
                        <div className='product-list'>
                          <div className="product-img-area">
                            <img src="assets/images/service/14.jpg" alt="Business-service" />
                            <div className='product-overlay'></div>
                          </div>
                          <h5>Hydraulic Centerless Grinding Machine</h5>
                          <p>Commodo gravida quamta sodales pulvinar habitant tristique auctore sapien pretiumto turpis dignissim mus feugiat</p>
                        </div>
                      </Link>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12 mb-4">
                      <Link to="">
                        <div className='product-list'>
                          <div className="product-img-area">
                            <img src="assets/images/service/14.jpg" alt="Business-service" />
                            <div className='product-overlay'></div>
                          </div>
                          <h5>Hydraulic Centerless Grinding Machine</h5>
                          <p>Commodo gravida quamta sodales pulvinar habitant tristique auctore sapien pretiumto turpis dignissim mus feugiat</p>
                        </div>
                      </Link>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12 mb-4">
                      <Link to="">
                        <div className='product-list'>
                          <div className="product-img-area">
                            <img src="assets/images/service/14.jpg" alt="Business-service" />
                            <div className='product-overlay'></div>
                          </div>
                          <h5>Hydraulic Centerless Grinding Machine</h5>
                          <p>Commodo gravida quamta sodales pulvinar habitant tristique auctore sapien pretiumto turpis dignissim mus feugiat</p>
                        </div>
                      </Link>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12 mb-4">
                      <Link to="">
                        <div className='product-list'>
                          <div className="product-img-area">
                            <img src="assets/images/service/14.jpg" alt="Business-service" />
                            <div className='product-overlay'></div>
                          </div>
                          <h5>Hydraulic Centerless Grinding Machine</h5>
                          <p>Commodo gravida quamta sodales pulvinar habitant tristique auctore sapien pretiumto turpis dignissim mus feugiat</p>
                        </div>
                      </Link>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12 mb-4">
                      <Link to="">
                        <div className='product-list'>
                          <div className="product-img-area">
                            <img src="assets/images/service/14.jpg" alt="Business-service" />
                            <div className='product-overlay'></div>
                          </div>
                          <h5>Hydraulic Centerless Grinding Machine</h5>
                          <p>Commodo gravida quamta sodales pulvinar habitant tristique auctore sapien pretiumto turpis dignissim mus feugiat</p>
                        </div>
                      </Link>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12 text-center">
                      <Link className="btn btn-primary" to="">
                        View All
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="tab-pane fade" id="internal">
                  <div className="row mb-2 justify-content-center">
                    <div className="col-lg-4 col-md-6 col-12 mb-4">
                      <Link to="">
                        <div className='product-list'>
                          <div className="product-img-area">
                            <img src="assets/images/service/14.jpg" alt="Business-service" />
                            <div className='product-overlay'></div>
                          </div>
                          <h5>Hydraulic Centerless Grinding Machine</h5>
                          <p>Commodo gravida quamta sodales pulvinar habitant tristique auctore sapien pretiumto turpis dignissim mus feugiat</p>
                        </div>
                      </Link>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12 mb-4">
                      <Link to="">
                        <div className='product-list'>
                          <div className="product-img-area">
                            <img src="assets/images/service/14.jpg" alt="Business-service" />
                            <div className='product-overlay'></div>
                          </div>
                          <h5>Hydraulic Centerless Grinding Machine</h5>
                          <p>Commodo gravida quamta sodales pulvinar habitant tristique auctore sapien pretiumto turpis dignissim mus feugiat</p>
                        </div>
                      </Link>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12 mb-4">
                      <Link to="">
                        <div className='product-list'>
                          <div className="product-img-area">
                            <img src="assets/images/service/14.jpg" alt="Business-service" />
                            <div className='product-overlay'></div>
                          </div>
                          <h5>Hydraulic Centerless Grinding Machine</h5>
                          <p>Commodo gravida quamta sodales pulvinar habitant tristique auctore sapien pretiumto turpis dignissim mus feugiat</p>
                        </div>
                      </Link>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12 mb-4">
                      <Link to="">
                        <div className='product-list'>
                          <div className="product-img-area">
                            <img src="assets/images/service/14.jpg" alt="Business-service" />
                            <div className='product-overlay'></div>
                          </div>
                          <h5>Hydraulic Centerless Grinding Machine</h5>
                          <p>Commodo gravida quamta sodales pulvinar habitant tristique auctore sapien pretiumto turpis dignissim mus feugiat</p>
                        </div>
                      </Link>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12 mb-4">
                      <Link to="">
                        <div className='product-list'>
                          <div className="product-img-area">
                            <img src="assets/images/service/14.jpg" alt="Business-service" />
                            <div className='product-overlay'></div>
                          </div>
                          <h5>Hydraulic Centerless Grinding Machine</h5>
                          <p>Commodo gravida quamta sodales pulvinar habitant tristique auctore sapien pretiumto turpis dignissim mus feugiat</p>
                        </div>
                      </Link>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12 text-center">
                      <Link className="btn btn-primary" to="">
                        View All
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="tab-pane fade" id="angular">
                  <div className="row mb-2 justify-content-center">
                    <div className="col-lg-4 col-md-6 col-12 mb-4">
                      <Link to="">
                        <div className='product-list'>
                          <div className="product-img-area">
                            <img src="assets/images/service/14.jpg" alt="Business-service" />
                            <div className='product-overlay'></div>
                          </div>
                          <h5>Hydraulic Centerless Grinding Machine</h5>
                          <p>Commodo gravida quamta sodales pulvinar habitant tristique auctore sapien pretiumto turpis dignissim mus feugiat</p>
                        </div>
                      </Link>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12 mb-4">
                      <Link to="">
                        <div className='product-list'>
                          <div className="product-img-area">
                            <img src="assets/images/service/14.jpg" alt="Business-service" />
                            <div className='product-overlay'></div>
                          </div>
                          <h5>Hydraulic Centerless Grinding Machine</h5>
                          <p>Commodo gravida quamta sodales pulvinar habitant tristique auctore sapien pretiumto turpis dignissim mus feugiat</p>
                        </div>
                      </Link>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12 mb-4">
                      <Link to="">
                        <div className='product-list'>
                          <div className="product-img-area">
                            <img src="assets/images/service/14.jpg" alt="Business-service" />
                            <div className='product-overlay'></div>
                          </div>
                          <h5>Hydraulic Centerless Grinding Machine</h5>
                          <p>Commodo gravida quamta sodales pulvinar habitant tristique auctore sapien pretiumto turpis dignissim mus feugiat</p>
                        </div>
                      </Link>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12 mb-4">
                      <Link to="">
                        <div className='product-list'>
                          <div className="product-img-area">
                            <img src="assets/images/service/14.jpg" alt="Business-service" />
                            <div className='product-overlay'></div>
                          </div>
                          <h5>Hydraulic Centerless Grinding Machine</h5>
                          <p>Commodo gravida quamta sodales pulvinar habitant tristique auctore sapien pretiumto turpis dignissim mus feugiat</p>
                        </div>
                      </Link>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12 mb-4">
                      <Link to="">
                        <div className='product-list'>
                          <div className="product-img-area">
                            <img src="assets/images/service/14.jpg" alt="Business-service" />
                            <div className='product-overlay'></div>
                          </div>
                          <h5>Hydraulic Centerless Grinding Machine</h5>
                          <p>Commodo gravida quamta sodales pulvinar habitant tristique auctore sapien pretiumto turpis dignissim mus feugiat</p>
                        </div>
                      </Link>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12 text-center">
                      <Link className="btn btn-primary" to="">
                        View All
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="tab-pane fade" id="spm">
                  <div className="row mb-2 justify-content-center">
                    <div className="col-lg-4 col-md-6 col-12 mb-4">
                      <Link to="">
                        <div className='product-list'>
                          <div className="product-img-area">
                            <img src="assets/images/service/14.jpg" alt="Business-service" />
                            <div className='product-overlay'></div>
                          </div>
                          <h5>Hydraulic Centerless Grinding Machine</h5>
                          <p>Commodo gravida quamta sodales pulvinar habitant tristique auctore sapien pretiumto turpis dignissim mus feugiat</p>
                        </div>
                      </Link>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12 mb-4">
                      <Link to="">
                        <div className='product-list'>
                          <div className="product-img-area">
                            <img src="assets/images/service/14.jpg" alt="Business-service" />
                            <div className='product-overlay'></div>
                          </div>
                          <h5>Hydraulic Centerless Grinding Machine</h5>
                          <p>Commodo gravida quamta sodales pulvinar habitant tristique auctore sapien pretiumto turpis dignissim mus feugiat</p>
                        </div>
                      </Link>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12 mb-4">
                      <Link to="">
                        <div className='product-list'>
                          <div className="product-img-area">
                            <img src="assets/images/service/14.jpg" alt="Business-service" />
                            <div className='product-overlay'></div>
                          </div>
                          <h5>Hydraulic Centerless Grinding Machine</h5>
                          <p>Commodo gravida quamta sodales pulvinar habitant tristique auctore sapien pretiumto turpis dignissim mus feugiat</p>
                        </div>
                      </Link>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12 mb-4">
                      <Link to="">
                        <div className='product-list'>
                          <div className="product-img-area">
                            <img src="assets/images/service/14.jpg" alt="Business-service" />
                            <div className='product-overlay'></div>
                          </div>
                          <h5>Hydraulic Centerless Grinding Machine</h5>
                          <p>Commodo gravida quamta sodales pulvinar habitant tristique auctore sapien pretiumto turpis dignissim mus feugiat</p>
                        </div>
                      </Link>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12 mb-4">
                      <Link to="">
                        <div className='product-list'>
                          <div className="product-img-area">
                            <img src="assets/images/service/14.jpg" alt="Business-service" />
                            <div className='product-overlay'></div>
                          </div>
                          <h5>Hydraulic Centerless Grinding Machine</h5>
                          <p>Commodo gravida quamta sodales pulvinar habitant tristique auctore sapien pretiumto turpis dignissim mus feugiat</p>
                        </div>
                      </Link>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12 text-center">
                      <Link className="btn btn-primary" to="">
                        View All
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>
      </section>


    </>
  )
}
